<style scoped>
    @import "./index.css";
    #tabBar {
        padding: 15px;
    }
</style>
<template>
    <div id="layout-container">

        <!--tabBar-->
        <!--<Row id="tabBar" type="flex" align="middle" justify="space-between">-->
            <!--<Col>-->
                <!---->
                <!--<ButtonGroup style="margin-left: 20px">-->
                    <!--<Button @click="activeIndex = 1" :class="[activeIndex==1 ? 'ivu-btn-primary' : '']">已提交</Button>-->
                    <!--<Button @click="activeIndex = 2" :class="[activeIndex==2 ? 'ivu-btn-primary' : '']">处理中</Button>-->
                    <!--<Button @click="activeIndex = 3" :class="[activeIndex==3 ? 'ivu-btn-primary' : '']">已修复</Button>-->
                <!--</ButtonGroup>-->
            <!--</Col>-->
        <!--</Row>-->
        <!--tabBar end-->

        <Tabs type="card" value="1" @on-click="onTabClick">
            <TabPane label="已提交" name="1"></TabPane>
            <TabPane label="处理中" name="2"></TabPane>
            <TabPane label="已修复" name="3"></TabPane>
        </Tabs>
        <Button @click="add" icon="md-add" type="primary">设备报修</Button>
        <!--列表-->
        <DragableTable
                refs="table"
                :loading="loading"
                :columns-list="columns"
                v-model="data"
        ></DragableTable>
        <!--列表 end-->
        <!--分页-->
        <Row id="tf-page" type="flex" align="middle" justify="space-between">
            <Col></Col>
            <Col>
                <Page :total="total" :page-size="pageSize" @on-change="onChangePage" @on-page-size-change="onChangeSizePage" show-elevator show-sizer></Page>
            </Col>
        </Row>
        <!--分页 end-->

        <!--右侧弹出窗口-->
        <Drawer :title="winTitle" :width="type == 1 ? 400 : 550" v-model="show">
            <div v-if="type == 1">
                <ul class="hxz-list-grout mt20">
                    <li class="list">
                        <div class="list-item flex flex-middle flex-between">
                            <label class="title">订单号</label>
                            <span class="right-txt">{{details.orderNo}}</span>
                        </div>
                    </li>
                    <li class="list">
                        <div class="list-item flex flex-middle flex-between">
                            <label class="title">设备分类</label>
                            <span class="right-txt">{{details.catName}}</span>
                        </div>
                    </li>
                    <li class="list">
                        <div class="list-item flex flex-middle flex-between">
                            <label class="title">设备名称</label>
                            <span class="right-txt">{{details.deviceName}}</span>
                        </div>
                    </li>
                    <li class="list">
                        <div class="list-item flex flex-middle flex-between">
                            <label class="title">提交时间</label>
                            <span class="right-txt">{{details.addTime}}</span>
                        </div>
                    </li>
                    <li class="list">
                        <div class="list-item flex flex-middle flex-between">
                            <label class="title">报修状态</label>
                            <span class="right-txt" id="tf-tag">
                                <Tag v-if="activeIndex == 2" color="success">{{details.repairStatusStr}}</Tag>
                                <Tag v-if="activeIndex == 3" color="warning">{{details.repairStatusStr}}</Tag>
                                <Tag v-if="activeIndex == 1" color="error">{{details.repairStatusStr}}</Tag>
                            </span>
                        </div>
                    </li>
                    <li class="list">
                        <div class="list-item">
                            <label class="title">请详细说明</label>
                        </div>
                        <p class="paragraph mt15">{{details.repairContent}}</p>
                    </li>
                </ul>
            </div>
            <baoXiu v-if="type == 2" @close="onClose"></baoXiu>
        </Drawer>
    </div>

</template>

<script>
    import { DragableTable } from "@/views/Components/Table";
    import baoXiu from "./baoxiu";

    export default {
        name: "add",
        components: {
            DragableTable,
            baoXiu
        },
        data() {
            return {
                loading:true,
                activeIndex:1,
                columns: [
                    {
                        title: "订单号",
                        align:'left',
                        key: "orderNo"
                    },
                    {
                        title: "详细说明",
                        key: "repairContent",
                        ellipsis:true
                    },
                    {
                        title: "报修状态",
                        key: "repairStatusStr",
                        render: (h, params) => {
                            if(params.row.repairStatusStr){
                                var _val = '',_type = '';
                                switch(parseInt(this.activeIndex)){
                                    case 1:
                                        _val  = '已提交';
                                        _type = 'error';
                                        break;
                                    case 2:
                                        _val = '处理中';
                                        _type = 'success';
                                        break;
                                    case 3:
                                        _val = '已修复';
                                        _type = 'primary';
                                        break;
                                }
                                return [
                                    h("Button", {
                                        props: {
                                            type: _type,
                                            size: 'small'
                                        }
                                    },_val)
                                ];
                            }else{
                                return h('span', '/');
                            }
                        }
                    },
                    {
                        title: "提交时间",
                        key: "addTime",
                        sortable: true
                    },
                    {
                        title: "操作",
                        align: "center",
                        render: (h, params) => {
                            return [
                                //查看
                                h("Button", {
                                    props: {
                                        icon: "ios-search",
                                        type: "primary",
                                        size: 'small'
                                    },
                                    nativeOn: {
                                        click: () => {
                                            this.showCon(params)
                                        }
                                    }
                                })
                            ];
                        }
                    }
                ],
                data: [],

                //侧边弹出+步骤索引
                show:false,
                winTitle: "",
                type:'', //1详情 2报修
                details:'',

                //分页
                pageNum:1,
                pageSize:10,
                total:0
            };
        },
        watch:{

        },
        created(){
            this.getData();
        },
        methods: {
            onTabClick(activeIndex){
                this.activeIndex = activeIndex;
                this.data = [];
                this.getData();
            },
            onChangePage(val){
                this.pageNum = val;
                this.getData();
            },
            onChangeSizePage(val){
                this.pageSize = val;
                this.getData();
            },
            //获取数据
            getData(){
                let that = this;
                this.loading = true;
                that.$func.ajax('customerRepairs',{
                    token :that.$func.getToken(),
                    repairStatus:that.activeIndex,
                    pageNum: that.pageNum,
                    pageSize: that.pageSize,
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.data  = r.pageInfo.list;
                        that.total = r.pageInfo.total;
                        that.loading = false;
                    }
                })
            },
            onClose(){
                this.show = false;
                this.getData();
            },
            //报修
            add(){
                this.show = true;
                this.type = 2;
                this.winTitle = '设备报修';
            },
            //查看
            showCon(params) {
                let that = this;
                that.show = true;
                that.type = 1;
                that.winTitle = '报修详情';
                //获取详情
                that.$func.ajax('customerRepair',{
                    token :that.$func.getToken(),
                    repairId:params.row.repairId
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.details  = r.type;
                    }
                })
            }
        }
    };
</script>
